"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M18.803 10.009c-1.595-1.814-4.474-2.461-6.636-2.461h-.191c-.175 0-.638.007-1.264.073a12.565 12.565 0 00-.802-.178C6.634 5.69 3.507 6.407 1.936 9.281.467 11.969-.171 15.416.039 19.528l.012.123c.253 1.867 1.582 2.98 3.498 2.866l.11-.012c.239-.037.469-.077.697-.12.853 1.47 2.403 1.999 4.037 1.35l.105-.048c.122-.062.239-.122.353-.185.251.303.516.61.802.928l.075.075c.712.666 1.527.999 2.343.999.816 0 1.632-.333 2.346-1.001l.082-.083c3.382-3.74 5.226-7.336 5.484-10.686.11-1.454-.286-2.707-1.18-3.725zm-1.131 6.961c-.987 2.421-2.506 4.577-4.22 6.474-.915.822-1.845.822-2.761 0a25.446 25.446 0 01-2.682-3.521c-2.441-3.888-2.449-6.594-2.449-6.594 0-2.832 2.783-3.954 5.039-4.242h.003c.487-.062.978-.097 1.469-.093 2.587-.019 6.511.912 6.511 4.335-.04 1.25-.446 2.504-.91 3.641zM6.444 22.517c-.43-.168-.761-.642-.967-1.057-1.182-3.108-2.183-7.211-1.03-10.495.608-1.591 2.15-2.257 3.686-2.257-6.239 2.386-2.575 9.669.244 13.415-.17.089-.33.18-.508.269-.428.161-.982.297-1.425.125zm-4.985-3.063c-.172-3.361.159-7.574 2.246-10.303.775-.969 1.922-1.373 3.093-1.248-5.433 1.144-3.788 9.293-2.51 13.025-.277.051-.55.105-.841.149-1.082.052-1.801-.461-1.988-1.623z" })));
};
var SvgPicks = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgPicks;
var templateObject_1;
